import axios, { API_URL } from '@propertypal/shared/src/services/axios';
import { ShowHomesResult } from '@propertypal/shared/src/types/show-homes';
import PageWrapper from '@propertypal/web-ui/src/layout/PageWrapper';
import PropertyGrid from '@propertypal/web-ui/src/property/PropertyGrid';
import { Heading } from '@propertypal/web-ui/src/typography';
import Head from 'next/head';
import React, { FunctionComponent } from 'react';
import MetaTags from '../../components/head/MetaTags';
import ShowHomesFilterBar from '../../components/show-homes/ShowHomesFilterBar';
import ShowHomesTable from '../../components/show-homes/ShowHomesTable';
import IMAGE_LOCATOR from '../../constants/imageLocator';
import { requireAuthToken } from '../../utils/auth';

interface Props {
  showHomes: ShowHomesResult;
  town: string;
}

export const getServerSideProps = requireAuthToken(async (ctx) => {
  const town = ctx?.query?.town ? ctx.query.town[0] : '';

  const result = await axios(
    {
      url: `${API_URL}/show-homes?imageLocator=${encodeURIComponent(IMAGE_LOCATOR)}${
        town ? `&url=%2Fnew-developments%2F${town}` : ''
      }`,
      method: 'GET',
    },
    undefined,
    ctx,
  );

  return {
    props: {
      showHomes: result.data,
      town,
    },
  };
});

const ShowHomeOpeningTimes: FunctionComponent<Props> = (props) => {
  return (
    <>
      <Head>
        <title>Show Home Opening Times - PropertyPal</title>

        <MetaTags
          description="Want To See A Glorious Home In Person? View The Upcoming Show Home Opening Times Across Ireland &amp; Northern Ireland."
          url="/show-home-opening-times"
        />
      </Head>

      <PageWrapper>
        <Heading mt={40} mb={40}>
          Show Home Opening Times
        </Heading>
      </PageWrapper>

      <ShowHomesFilterBar primaryTowns={props.showHomes.primaryTowns} town={props.town} />

      <PropertyGrid
        containerStyle={{ maxWidth: 1260, margin: '0 auto' }}
        maxColumns={3}
        properties={props.showHomes.featured}
        disablePropertyAd
      />

      <ShowHomesTable showHomes={props.showHomes.showHomes} totalDevelopments={props.showHomes.totalDevelopments} />
    </>
  );
};

export default ShowHomeOpeningTimes;
